import { NavLink } from 'react-router-dom';
import {
  formatDate,
  IconAttention,
  IconChat,
  IconClock,
  IconDownload,
  IconEdit,
  IconTrash,
  PermissionEnum,
} from '@ui/src';
import { OrganizationType } from '../../types';
import { CustomerDocument } from '../types';

import cn from '../styles.module.css';

const formatExpiredDocumentsList = (
  list: CustomerDocument[],
  setSubMenuVisible: (data: boolean) => void,
  setSelectedSubMenuDocumentId: (data: string) => void,
  setRenamePopupVisible: (data: boolean) => void,
  setSelectedDocumentToRename: (data: CustomerDocument) => void,
  getFile: (data: CustomerDocument) => void,
  setDeletePopupVisible: (data: boolean) => void,
  setSelectedDeleteDocument: (data: CustomerDocument) => void,
  type: OrganizationType,
  subMenuVisible?: boolean,
  selectedSubMenuDocumentId?: string,
  documentRenameAvailable?: boolean,
  activePermissions?: PermissionEnum[],
  search?: string,
): CustomerDocument[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      createdAt: <div>{formatDate(result.createdAt)}</div>,
      expirationDate: (
        <div className={cn.expiredDocumentRow}>
          {formatDate(result.expirationDate)}{' '}
          <IconClock className={cn.expiredIcon} />
        </div>
      ),
      status: (
        <div className={cn.expiredStatus}>
          <div className={cn.expiredStatusLeft}>
            <span>Expired</span>
            <span>
              <IconAttention className={cn.expiredStatusIcon} />
            </span>
          </div>

          <div className={cn.documentRowRightContentRight}>
            <div className={cn.documentsRowComments}>
              {item?.countComments && item?.countComments.count > 0 && (
                <>
                  <IconChat
                    className={cn.documentsRowCommentIcon}
                    width={14}
                    height={14}
                  />
                  {item?.countComments.count}
                </>
              )}
            </div>
            <div
              className={`${cn.expiredDocumentMenuWrapper} ${
                subMenuVisible && selectedSubMenuDocumentId === item.id
                  ? cn.expiredDocumentMenuWrapperActive
                  : ''
              }`}
            >
              <button
                type="button"
                aria-label="Show menu"
                className={`${cn.expiredDocumentsRowMenuButton} ${
                  subMenuVisible && selectedSubMenuDocumentId === item.id
                    ? cn.expiredDocumentsRowMenuButtonActive
                    : ''
                }`}
                onClick={() => {
                  setSubMenuVisible(!subMenuVisible);

                  if (subMenuVisible) {
                    setSelectedSubMenuDocumentId('');
                  } else {
                    setSelectedSubMenuDocumentId(item.id);
                  }
                }}
              >
                <span />
              </button>
              {subMenuVisible && selectedSubMenuDocumentId === item.id && (
                <ul className={cn.expiredDocumentsRowMenu}>
                  {documentRenameAvailable && (
                    <li>
                      <button
                        type="button"
                        className={cn.documentsMenuButton}
                        onClick={() => {
                          setRenamePopupVisible(true);
                          setSelectedDocumentToRename(item);
                          setSubMenuVisible(false);
                          setSelectedSubMenuDocumentId('');
                        }}
                      >
                        <IconEdit className={cn.documentsMenuButtonIcon} />
                        Rename
                      </button>
                    </li>
                  )}
                  <li>
                    <NavLink
                      to={`${item.url}${search || ''}#comments`}
                      className={`${cn.documentsMenuButton} ${cn.documentMenuButtonLink}`}
                      onClick={() => {
                        setSubMenuVisible(false);
                        setSelectedSubMenuDocumentId('');
                      }}
                    >
                      <IconChat
                        className={`${cn.documentsMenuButtonIcon} ${cn.documentCommentIcon}`}
                      />
                      Comments
                    </NavLink>
                  </li>
                  <li>
                    <button
                      type="button"
                      className={cn.documentsMenuButton}
                      onClick={() => getFile(item)}
                    >
                      <IconDownload className={cn.documentsMenuButtonIcon} />
                      Download
                    </button>
                  </li>
                  {((type === OrganizationType.INDIVIDUAL &&
                    activePermissions?.includes(
                      PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
                    )) ||
                    (type === OrganizationType.CORPORATE &&
                      activePermissions?.includes(
                        PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
                      ))) && (
                    <li>
                      <button
                        type="button"
                        className={cn.documentsMenuButton}
                        onClick={() => {
                          setDeletePopupVisible(true);
                          setSubMenuVisible(false);
                          setSelectedDeleteDocument(item);
                        }}
                      >
                        <IconTrash
                          className={`${cn.documentsMenuButtonIcon} ${cn.documentDeleteIcon}`}
                        />
                        Delete
                      </button>
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatExpiredDocumentsList;
